import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { TENANT_URL } from '@src/routes/tenant';
import { getCompanyContactUrl } from '@src/utils/companyContactUrl';

import { Menu } from '../../types/menu';

type MenuResponse = Menu[];

// お問い合わせフォームが「URL版」方式のテナントでは、問い合わせが本アプリに蓄積されないため導線自体を非表示にする。
// メニューはグループ配下にネストする場合があるため、子孫も再帰的に除外し、子項目が空になったグループも併せて除外する。
const excludeContactMenuItems = (items: Menu[]): Menu[] => {
  return items.reduce<Menu[]>((filteredItems, item) => {
    if (item.link === TENANT_URL.CONTACTS) {
      return filteredItems;
    }

    const filteredChildren = excludeContactMenuItems(item.items);
    const emptiedGroup = item.items.length > 0 && filteredChildren.length === 0;
    if (emptiedGroup) {
      return filteredItems;
    }

    return [...filteredItems, { ...item, items: filteredChildren }];
  }, []);
};

const excludeContactMenu = (menus: MenuResponse): MenuResponse => {
  return menus
    .map((section) => ({ ...section, items: excludeContactMenuItems(section.items) }))
    .filter((section) => section.items.length > 0);
};

export const tenantMenuApiClient = {
  index: async (): Promise<ApiResult<MenuResponse>> => {
    const res: ApiResult<MenuResponse> = await axiosClient.get('/tenant/menus');
    if (res.result !== 'success' || !getCompanyContactUrl()) {
      return res;
    }
    return { ...res, data: excludeContactMenu(res.data) };
  },
};
